/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Select. Sizing is owned by form/inputOutlined.js (the Select root *is* an
 * OutlinedInput); this file only shapes the value box and the caret.
 *
 * The caret used to be hidden here, which is why so many pages carried their
 * own `IconComponent` arrow. It is a real, themed icon again: positioned by
 * MUI, coloured like the outline, and it turns when the menu is open.
 */

import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { outline, transparent } = colors;
const { borderRadius } = borders;

const select = {
  styleOverrides: {
    select: {
      display: "flex",
      alignItems: "center",
      gap: pxToRem(6),
      minHeight: 0,
      borderRadius: borderRadius.md,
      "&:focus": {
        backgroundColor: transparent.main,
        borderRadius: borderRadius.md,
      },
      "&.MuiSelect-multiple": {
        flexWrap: "wrap",
        paddingTop: pxToRem(4),
        paddingBottom: pxToRem(4),
      },
    },

    icon: {
      display: "block",
      width: pxToRem(20),
      height: pxToRem(20),
      fontSize: pxToRem(20),
      right: pxToRem(10),
      top: "calc(50% - 10px)",
      color: outline.main,
      transition: "transform 150ms ease",
      "&.Mui-disabled": {
        color: outline.variant,
      },
    },
    iconOpen: {
      transform: "rotate(180deg)",
    },
  },
};

export default select;
